export const DEFAULT_SYSTEM_SCHEMAS = ['information_schema', 'pg_catalog', 'pg_toast']
export const DEFAULT_PLATFORM_APPLICATION_NAME = 'supabase/dashboard'
